module.exports = __webpack_public_path__ + "static/img/image1.84be24b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/image1.jpeg
// module id = MObE
// module chunks = 26